import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { useForm } from "react-hook-form";
import {
  FormProvider,
  FormTextField,
  Page,
  TextField,
  useSnackbarContext,
  VerticalBox,
} from "@inductiveautomation/ws-components";

import { handleResponse } from "../../../../utilities/api_response";
import {
  useGetMakerLicenseDetailsQuery,
  usePostMakerLicenseNameMutation,
} from "../../api/makerLicenses.api";
import { addDashToKey } from "../utilities";

const Details = () => {
  const [updateName] = usePostMakerLicenseNameMutation();
  const { t } = useTranslation("translation", {
    keyPrefix: "maker_license.tabs.details.form",
  });
  const { addSnackbar } = useSnackbarContext();
  const { id } = useParams();

  const { data: apiData, refetch } = useGetMakerLicenseDetailsQuery(
    {
      licenseKey: id ?? "",
    },
    { skip: !id }
  );

  const formMethods = useForm({
    defaultValues: {
      name: apiData ? apiData.name : "",
    },
  });

  const onSubmit = formMethods.handleSubmit((data) => {
    if (!apiData || data.name == apiData.name) return;
    updateName({
      licenseKey: apiData.key,
      licenseNamePayload: {
        licenseName: data.name ?? "",
      },
    })
      .then((response) => {
        handleResponse(response, {
          onSuccess: () => {
            addSnackbar(t("name.success_message"));
            void refetch();
          },
          onError: () => {
            addSnackbar(t("name.error_message"), {
              type: "error",
            });
          },
        });
      })
      .catch((error: unknown) => {
        console.error(error);
        addSnackbar(t("name.error_message"), {
          type: "error",
        });
      });
  });

  return (
    <Page
      fullWidth
      itemBannerProps={{
        readOnly: true,
        avatarProps: {
          icon: "license",
          iconAvatarColor: "maker",
        },
      }}
      sections={[
        {
          heading: t("heading"),
          description: "",
          children: (
            <FormProvider {...formMethods}>
              <form onBlur={(e) => void onSubmit(e)}>
                <VerticalBox gap="1.5rem">
                  <TextField
                    id="license-key"
                    label={t("key.label")}
                    handleOnChange={() => undefined}
                    value={apiData ? addDashToKey(apiData.key) : ""}
                    isReadOnly
                  />

                  <FormTextField
                    prefix="license"
                    name="name"
                    label={t("name.label")}
                  />
                </VerticalBox>
              </form>
            </FormProvider>
          ),
        },
      ]}
    />
  );
};

export default Details;
